import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    isUploadingSurvey: false,
    uploadedSurveyVerification: {},
    statusSurvey : "Pendiente", // "Pendiente", En Proceso, Completado, "Error",
    lastSurvey : [],
    isUploadingResponse: false,
    uploadedResponseVerification: {},
    statusResponse : "Pendiente", // "Pendiente", En Proceso, Completado, "Error",
    lastResponse : []

};

export const surveySlice = createSlice({
    name: "survey",
    initialState,
    reducers: {
        uploadSurvey: (state) => {
            state.uploadedSurveyVerification = {}
        },
        setUploadingSurvey: (state, { payload }) => {
            state.isUploadingSurvey = payload
        },
        uploadedSurvey: (state, action) => {
            state.isUploadingSurvey = false;
            state.uploadedSurveyVerification = action.payload
        },
        setStatusSurvey: ( state, {payload }) => {
            state.statusSurvey = payload
        },
        setLastSurvey: (state, {payload }) => {
            state.lastSurvey = payload
        },
        uploadResponse: (state) => {
            state.uploadedResponseVerification = {}
        },
        setUploadingResponse: (state, { payload }) => {
            state.isUploadingResponse = payload
        },
        uploadedResponse: (state, action) => {
            state.isUploadingResponse = false;
            state.uploadedResponseVerification = action.payload
        },
        setStatusResponse: ( state, {payload }) => {
            state.statusResponse = payload
        },
        setLastResponse: (state, {payload }) => {
            state.lastResponse = payload
        }
    },
});
export const surveyActions = surveySlice.actions;

export default surveySlice.reducer;
